"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElementalShockFireAbilityHandler = exports.ElementalShockFireActorAbilityFactory = exports.ElementalShockFireAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
class ElementalShockFireAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ElementalShockFire;
        this.__typeName = "ElementalShockFire";
    }
}
exports.ElementalShockFireAbilityArgs = ElementalShockFireAbilityArgs;
let ElementalShockFireActorAbilityFactory = class ElementalShockFireActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ElementalShockFire", "AllEnemies", 0);
    }
};
ElementalShockFireActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ElementalShockFire")
], ElementalShockFireActorAbilityFactory);
exports.ElementalShockFireActorAbilityFactory = ElementalShockFireActorAbilityFactory;
let ElementalShockFireAbilityHandler = class ElementalShockFireAbilityHandler {
    init(sequence, container, actorId) {
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            duration: Duration_1.Duration.Permanent,
            effect: new core_1.LinkedEventHandlerEffectArgs("Elemental Shock: Fire", "Burns killer", false, container.registerEventHandlerScript(actorId, EventType_1.EventType.Killed, Schedule_1.Schedule.Once(), "ApplyEffects_OnKilled", {
                target: "killer",
                effects: [{
                        duration: Duration_1.Duration.Ticks(8),
                        effect: new core_1.BurningEffectArgs("Focus", 20),
                        percentChance: 100
                    }]
            })),
            supernatural: true,
        });
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
ElementalShockFireAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ElementalShockFire)
], ElementalShockFireAbilityHandler);
exports.ElementalShockFireAbilityHandler = ElementalShockFireAbilityHandler;
